import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function KycAmlInfo() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="footer-kyc-aml-link"
        className="text-sm text-ink2 hover:text-ink underline-offset-4 hover:underline transition-colors text-left"
      >
        KYC / AML
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8 bg-ink/70 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="kyc-aml-info-overlay"
        >
          <div
            className="relative w-full max-w-2xl bg-bg border border-ink shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="border-b border-line px-6 py-4 flex items-center justify-between sticky top-0 bg-bg">
              <div>
                <div className="label-tag">{t("kyc_aml.tag")}</div>
                <div className="font-serif text-2xl mt-1">{t("kyc_aml.title")}</div>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                data-testid="kyc-aml-info-close"
                aria-label={t("kyc_aml.close")}
                className="text-ink2 hover:text-ink text-2xl leading-none px-2"
              >
                ×
              </button>
            </div>

            <div className="px-6 py-6 space-y-5 text-sm text-ink2 leading-relaxed">
              <p>{t("kyc_aml.intro")}</p>

              <div className="border border-line bg-surface p-4">
                <div className="font-serif text-ink text-lg">{t("kyc_aml.kyc_h")}</div>
                <p className="mt-2">{t("kyc_aml.kyc_p")}</p>
              </div>

              <div className="border border-line bg-surface p-4">
                <div className="font-serif text-ink text-lg">{t("kyc_aml.aml_h")}</div>
                <p className="mt-2">{t("kyc_aml.aml_p")}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
